import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    wpaqq: "https://wpa1.qq.com/Z1P9eP8O?_type=wpa&qidian=true",
    to_register: "https://console.todesk.com/#/register",
    wbook: "https://enterprise.todesk.com/contact", //获取白皮书
    contact_way: "https://enterprise.todesk.com/contact", //联系我们表单
    contact_way2: "https://enterprise.todesk.com/contact", //联系我们表单2
    MenuShadow: true,
  },
  mutations: {
    setMenuShadow(state, val) {
      state.MenuShadow = val;
    },
  },
});
